module.exports = __webpack_public_path__ + "static/media/banner-instagram.96813452.png";